import { Email, GitHub, LinkedIn } from "@mui/icons-material";
const Contact = [
  {
    icon: <Email />,
    link: "mailto:g820324@gmail.com",
  },
  {
    icon: <GitHub />,
    link: "https://github.com/RayHaha",
  },
  {
    icon: <LinkedIn />,
    link: "https://www.linkedin.com/in/yu-jui-chang/",
  },
];

export default Contact;
